import React, { useState } from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import TextareaAutosize  from '@mui/material/TextareaAutosize';
import Divider from '@mui/material/Divider';
import EqualizerIcon from '@mui/icons-material/InsertChartOutlined';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

import { AutoSaveProvider, useAutoSaveState, SaveButton, NameField } from '../lib/useAutoSaveState'
import { createBins, standardDeviation } from '../lib/stats'
import toFixed from '../lib/toFixed'

function StandardDeviation () {
  const [data, setData] = useAutoSaveState('data', '')
  const [ preview, setPreview ] = useAutoSaveState('preview', null)
  const [result, setResult] = useState(null)
  const [histogramData, setHistogramData] = useState({})

  const calculate = () => {
    const input = data.split(/[^0-9.-]/).filter(v => v).map(v => parseFloat(v))
    console.log(input)
    const output = {
      sd: standardDeviation(input),
    }
    console.log({ output })
    const bins = createBins(input, 15)
    console.log({ bins })
    setHistogramData(bins)
    setResult(output)
    setPreview(`SD: ${toFixed(output.sd, 3)}`)
    window.gtag('event', 'calculate-standard-deviation')
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Grid container spacing={3}>
        <Grid container justifyContent="center" xs={12} style={{ position: 'relative' }}>
          <Typography variant="h2" component="h1" gutterBottom>
            Standard Deviation
          </Typography>
          <SaveButton />
        </Grid>
        <NameField />
        <Grid item xs={12}>
          <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="body1">Values</Typography>
                <TextareaAutosize
                  style={{ width: '100%' }}
                  aria-label="data"
                  minRows={3}
                  maxRows={20}
                  placeholder="Enter data..."
                  value={data}
                  onChange={e => setData(e.target.value)}
                />
              </Grid>
            </Grid>
            <Grid container xs={12} justifyContent="center">
              <Button variant="contained" onClick={calculate}>Calculate</Button>
            </Grid>
          </Paper>
        </Grid>
        {result && <Grid item xs={12}>
          <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
            <Grid container xs={12} justifyContent="center">
              <Typography variant="h5" gutterBottom>
                <EqualizerIcon /> Standard Deviation Results
              </Typography>
            </Grid>
            <Divider style={{ marginBottom: '20px' }} />

            <Box display="flex" justifyContent="space-around" mb={2}>
              <Typography variant="body1"><b>Standard Deviation (SD):</b> {toFixed(result.sd, 3)}</Typography>
            </Box>
            <Divider style={{ marginBottom: '20px', marginTop: '20px' }} />

          </Paper>
        </Grid>}
        {result && <Grid item xs={12}>
          <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
            <KSHistogram data={histogramData} />
          </Paper>
        </Grid>}
      </Grid>
    </Container>
  );
}

const KSHistogram = ({ data }) => {
  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="bin" />
        <YAxis />
        <Tooltip />
        <Bar dataKey="count" fill="#8884d8" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default function WrappedStandardDeviation () {
  return (
    <AutoSaveProvider>
      <StandardDeviation />
    </AutoSaveProvider>
  )
}
